<template>
  <el-autocomplete
    v-input-focus
    :disabled="disabled"
    :fetch-suggestions="
      (qs, cb) => {
        queryAPI({ name: qs }, cb);
      }
    "
    :debounce="0"
    :placeholder="placeholder"
    popper-class="cm-port-list-popper-class"
    :value="value"
    @change="
      (e) => {
        $emit('change', e);
      }
    "
    @select="
      (e) => {
        $emit('select', e);
      }
    "
    @input="
      (e) => {
        $emit('input', e);
      }
    "
  >
    <template v-slot="{ item }">
      <!-- <div class="cm-auto">
        <span>{{ $str(item.name, "", "${} ") }}</span>
        <span
          >({{ $str(item.nameCn, "", "${} | ") }}
          {{ $str(item.countryName, "", "${}") }})</span
        >
      </div> -->
      <AutoPortTemplate :detail="item" :showCountryFlag="false"></AutoPortTemplate>
    </template>
  </el-autocomplete>
</template>

<script>
import  AutoPortTemplate  from "@/components/input/AutoPortTemplate.vue";
import { jsonPost } from "@/utils/request";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择港口",
    },
    value: [String, Number],
    type: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isStart: {
      type: Boolean,
      default: false,
    },
  },
  components: { AutoPortTemplate },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    async queryAPI(params, cb) {
      if (this.isStart) {
        params.loadportFlag = 1;
      }

      let res = await jsonPost({
        url: `/combobox/querycarriertaskport`,
        params,
      });
      res = res;
      let list = res || [];
      let filter = [];
      if (list && list.length > 0) {
        filter = list.filter((item) => item.id);
      }

      if (cb) {
        cb(filter || []);
      }

      return filter;
    },
  },
};
</script>

<style scoped lang="scss"></style>
